'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FilterOption {
  value: string;
  label: string;
}

interface FilterBarProps {
  industries: FilterOption[];
  companySizes: FilterOption[];
  useCases: FilterOption[];
  outcomes: FilterOption[];
  selectedIndustry: string;
  selectedCompanySize: string;
  selectedUseCase: string;
  selectedOutcome: string;
  onIndustryChange: (value: string) => void;
  onCompanySizeChange: (value: string) => void;
  onUseCaseChange: (value: string) => void;
  onOutcomeChange: (value: string) => void;
  onReset: () => void;
}

const FilterBar = ({
  industries,
  companySizes,
  useCases,
  outcomes,
  selectedIndustry,
  selectedCompanySize,
  selectedUseCase,
  selectedOutcome,
  onIndustryChange,
  onCompanySizeChange,
  onUseCaseChange,
  onOutcomeChange,
  onReset,
}: FilterBarProps) => {
  const hasActiveFilters = selectedIndustry !== 'all' || selectedCompanySize !== 'all' || selectedUseCase !== 'all' || selectedOutcome !== 'all';

  return (
    <div className="bg-card rounded-lg shadow-subtle p-6 mb-8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-display font-semibold text-foreground">
          Filter Case Studies
        </h3>
        {hasActiveFilters && (
          <button
            onClick={onReset}
            className="flex items-center space-x-1 text-sm text-primary hover:text-primary/80 transition-colors duration-200"
          >
            <Icon name="XMarkIcon" size={16} />
            <span>Reset Filters</span>
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Industry
          </label>
          <select
            value={selectedIndustry}
            onChange={(e) => onIndustryChange(e.target.value)}
            className="w-full px-4 py-2.5 bg-background border border-input rounded-lg text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-200"
          >
            {industries.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Company Size
          </label>
          <select
            value={selectedCompanySize}
            onChange={(e) => onCompanySizeChange(e.target.value)}
            className="w-full px-4 py-2.5 bg-background border border-input rounded-lg text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-200"
          >
            {companySizes.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Use Case
          </label>
          <select
            value={selectedUseCase}
            onChange={(e) => onUseCaseChange(e.target.value)}
            className="w-full px-4 py-2.5 bg-background border border-input rounded-lg text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-200"
          >
            {useCases.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Outcome Type
          </label>
          <select
            value={selectedOutcome}
            onChange={(e) => onOutcomeChange(e.target.value)}
            className="w-full px-4 py-2.5 bg-background border border-input rounded-lg text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-200"
          >
            {outcomes.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;